import React from 'react'
import {
  DialogOverlay,
  DialogOverlayActions,
  H3,
  Paragraph,
  Separator,
  Subheading,
  type UseOverlayReturnOptions,
} from '@fs/zion-ui'
import { useTranslation } from 'react-i18next'
import { type ReactNodeLike } from 'prop-types'
import { PillButton } from '../buttons'

type FieldHelpSection = {
  heading: ReactNodeLike
  subheading: ReactNodeLike
}

type FieldHelpOverlayProps = {
  overlay: UseOverlayReturnOptions
  title: string
  body: ReactNodeLike
  sections: FieldHelpSection[]
}

export default function FieldHelpOverlay({ overlay, title, body, sections }: FieldHelpOverlayProps): JSX.Element {
  const [t] = useTranslation()

  return (
    <DialogOverlay
      {...overlay}
      title={title}
      closeOnClickAway
      footer={
        <DialogOverlayActions>
          <PillButton onClick={overlay.handleClick}>{t('common-ui:ok.action', 'OK')}</PillButton>
        </DialogOverlayActions>
      }
    >
      <Paragraph size="md">{body}</Paragraph>
      {sections.map(({ heading, subheading }) => (
        <React.Fragment key={heading?.toString() ?? ''}>
          <Separator size="xs" />
          <H3 size="H5" supplementary>
            {heading}
            <Subheading>{subheading}</Subheading>
          </H3>
        </React.Fragment>
      ))}
    </DialogOverlay>
  )
}
